if (typeof document === "undefined") return;
var createStylesheet = (chunkId, fullhref, oldTag, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;
	if (linkTag.href.indexOf(window.location.origin + '/') !== 0) {
		linkTag.crossOrigin = "anonymous";
	}
	if (oldTag) {
		oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
	} else {
		document.head.appendChild(linkTag);
	}
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	"front-office_app": 0,
	"front-office_libs": 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"front-office-components":1,"widget-comments-block-comments":1,"packages_widget-legacy_widget-legacy-post-list_components_LegacyContributionField_LegacyContr-3f3656":1,"tutorials-details":1,"gdpr-banner":1,"mobile-app-modal":1,"community-navigation":1,"social-advocacy-dashboard":1,"terms-and-conditions-modal":1,"emoji-picker":1,"block-play":1,"uploading-video-dialog":1,"playlist-library":1,"lazy-playlist":1,"micro-app-picker-dialog":1,"widget-micro-app":1,"share-content-dropdown":1,"nanny-details-modal":1,"responsive-main-side-navigation":1,"community-picker-dialog":1,"event-notification-dialog":1,"post-dialog":1,"widget-post-list-block-post":1,"reports":1,"advanced-debug-info":1,"community-configuration-dialog":1,"widget-article-list-block-article-preview":1,"widget-base-block-reactions":1,"block-structured-content":1,"widget-event-list-block-event-preview":1,"block-event-metadata":1,"block-contribution-field":1,"lumx-calendar":1,"widget-comments-block-comments-v2":1,"widget-file-list":1,"widget-metadata-block-metadata":1,"content-picker":1,"video-upload-dialog":1,"assistant-main-window":1,"event-dialog":1,"video-editor":1,"create-playlist-dialog":1,"playlist-editor":1,"share-to-extension-dialog":1,"share-to-slack-dialog":1,"share-to-teams-dialog":1,"article-dialog":1,"shared-with-dialog":1,"insert-images-choices-dialog":1,"comment-editor-block":1,"play-dashboard":1,"create-podcast-dialog":1,"playlist-parameters-dialog":1,"draggable-wrapper":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr